import { __decorate } from "tslib";
import { I18nThemed } from 'interfaces/mixins';
import { theme } from '@dojo/framework/core/mixins/Themed';
import { Keys } from '@holmescorp/common';
import { v, w } from '@dojo/framework/core/vdom';
import { storeInject } from '@dojo/framework/stores/StoreInjector';
import { keymap, pathmap } from 'lcc-state';
import { numeral } from '@holmescorp/numeral';
import { Circle, Line } from 'progress-bar';
import { TopicSet } from './topicset';
import css from '../css/topichead.m.css';
let Status = class Status extends I18nThemed {
    render() {
        const { key = '', status, assessment, messages } = this.properties;
        const proficiency = messages['your_proficiency'] || '';
        const progress = messages['your_progress'] || '';
        if (status === undefined || status[key] === undefined) {
            const legendPercent = numeral(0).format('0%');
            return v('div', { key: `${key}-status`, classes: [this.theme(css.status)] }, [
                w(Circle, { key: `${key}-1`, progress: 0, legend: legendPercent, title: proficiency }),
                w(Line, { key: `${key}-2`, progress: 0, total: 0, title: progress })
            ]);
        }
        else {
            const { complete, total, percent } = status[key].data;
            const assess = assessment ? assessment[key] : { data: { percent: 0 } };
            const { percent: innerPercent = 0 } = assess.data;
            const legendPercent = numeral(percent).format('0%');
            return v('div', { key: `${key}-status`, classes: [this.theme(css.status)] }, [
                w(Circle, {
                    key: `${key}-1`,
                    progress: percent * 100,
                    inner: +innerPercent,
                    legend: legendPercent,
                    title: proficiency
                }),
                w(Line, { key: `${key}-2`, progress: complete, total, title: progress })
            ]);
        }
    }
};
Status = __decorate([
    theme(css),
    storeInject({
        name: 'user-state',
        paths: [['status'], ['assessment']],
        getProperties: (store) => {
            const { get, path } = store;
            return {
                status: get(path('status')),
                assessment: get(path('assessment'))
            };
        }
    })
], Status);
let TopicHead = class TopicHead extends I18nThemed {
    _firstSet = undefined;
    _selected() {
        if (this._firstSet) {
            const { path } = keymap.get(this._firstSet);
            const { view } = pathmap.get(path);
            view();
        }
    }
    _onKeyDown(event) {
        event.stopPropagation();
        switch (event.key) {
            case Keys.Enter:
            case Keys.Space:
            case Keys.Spacebar:
                event.preventDefault();
                this._selected();
                break;
        }
    }
    get_nls() {
        const { dynls } = this.properties;
        const bundle = dynls.get('ditabook');
        if (!bundle) {
            return { isPlaceholder: true, format: () => '', messages: {} };
        }
        return this.localizeBundle(bundle);
    }
    render() {
        const { isPlaceholder, messages } = this.get_nls();
        if (isPlaceholder) {
            return null;
        }
        const { topic: { attributes = {}, children = [] } } = this.properties;
        const { topic } = this.properties;
        const { title, key } = attributes;
        const kids = children.map((val, idx) => {
            const { attributes, children = [] } = val['topicset'];
            if (idx === 0) {
                this._firstSet = attributes.key;
            }
            return w(TopicSet, { topic: { attributes, children }, topichead: topic });
        });
        return v('div', {
            key,
            tabIndex: 0,
            classes: [this.theme(css.root), key],
            xqa: `topichead ${key}`,
            onclick: (event) => {
                event && event.stopImmediatePropagation();
                this._selected();
            },
            onkeydown: this._onKeyDown
        }, [v('div', { classes: [this.theme(css.title)] }, [title]), w(Status, { key, messages }), ...kids]);
    }
};
TopicHead = __decorate([
    theme(css),
    storeInject({
        name: 'lcc-state',
        paths: [['dynls']],
        getProperties: (store) => {
            const { get, path } = store;
            return {
                dynls: get(path('dynls'))
            };
        }
    })
], TopicHead);
export { TopicHead };
